<template>
  <div class="form-group mb-3">
    <label class="form-label fw-bold mb-2">Activité(s) professionnelle(s) garantie(s)</label>
    <div
      v-for="(choice, index) in activityChoices"
      :key="`card-activity-${index}`"
      class="custom-control custom-checkbox mb-2"
    >
      <label
        :for="`card-activity-${index}`"
        class="form-check-label fw-normal mb-0"
      >
        <input
          :id="`card-activity-${index}`"
          :checked="localActivities.includes(choice.value)"
          :value="choice.value"
          type="checkbox"
          class="form-check-input"
          @change="toggleActivity(choice.value, $event.target.checked)"
        >
        {{ choice.label }}
      </label>
    </div>
    <div
      v-if="activitiesError"
      class="small text-danger mt-2"
    >
      {{ activitiesErrorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivitiesSection',
  props: {
    activityChoices: { type: Array, required: true },
    localActivities: { type: Array, required: true },
  },
  emits: ['update'],
  data() {
    return {
      hasBeenTouched: false,
    };
  },
  computed: {
    activitiesError() {
      return this.hasBeenTouched && this.localActivities.length === 0;
    },
    activitiesErrorMessage() {
      return 'Veuillez sélectionner au moins une activité';
    },
  },
  watch: {
    localActivities: {
      handler(newVal, oldVal) {
        if (oldVal && oldVal.length > 0 && newVal.length === 0) {
          this.hasBeenTouched = true;
        }
      },
    },
  },
  methods: {
    toggleActivity(activity, checked) {
      this.hasBeenTouched = true;
      const nextActivities = checked
        ? [...this.localActivities, activity]
        : this.localActivities.filter((value) => value !== activity);

      this.$emit('update', nextActivities);
    },
  },
};
</script>
